import { render, staticRenderFns } from "./RepetitionsTooltip.vue?vue&type=template&id=a5869528&"
import script from "./RepetitionsTooltip.vue?vue&type=script&lang=ts&"
export * from "./RepetitionsTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports